export default function onListItemHref() {
    const anchor = this.querySelector('a');

    if (!anchor) return;
    anchor.classList.add('active');
    window.location = anchor.href;
}
